<i
  [ngClass]="'size__' + size()"
  class="fa-duotone fa-solid fa-spinner-third fa-spin osp-spinner"
></i>
